import { EReliabilityType } from '../../../types/developerV2/reliability';

export type TTheme = 'green' | 'red';

export const statusToTheme = (status: EReliabilityType): TTheme => {
  const themes = {
    [EReliabilityType.Problem]: 'red',
    [EReliabilityType.Reliable]: 'green',
  };

  return themes[status] as TTheme;
};
